import type { NodeViewProps } from "@tiptap/react";
import type { Variables } from "@/lib/sparxs/metadataSchemas";

export const filterVariablesByDirective = (
  variables: Variables[],
  directiveTypes: string[],
): Variables[] =>
  variables.filter((v) => v.type != null && directiveTypes.includes(v.type));

export const updateRawAtPos = (
  editor: NodeViewProps["editor"],
  getPos: NodeViewProps["getPos"],
  raw: string,
  options?: { focus?: boolean },
) => {
  const focus = options?.focus !== false;
  const pos = typeof getPos === "function" ? getPos() : undefined;
  if (typeof pos !== "number") return;
  const chain = editor.chain();
  if (focus) chain.focus();
  chain.setNodeSelection(pos).updateAttributes("variableToken", { raw }).run();
};

export const focusEditorAfterNode = (
  editor: NodeViewProps["editor"],
  getPos: NodeViewProps["getPos"],
) => {
  const pos = typeof getPos === "function" ? getPos() : undefined;
  if (typeof pos !== "number") return;
  const node = editor.state.doc.nodeAt(pos);
  if (node) {
    editor
      .chain()
      .focus()
      .setTextSelection(pos + node.nodeSize)
      .run();
  }
};
